import axios from "axios";

export async function fetchBroadcastChannelList() {
  return axios.request({
    url: `/r-api/broadcast_channel`,
    method: "GET",
  });
}
